export type Tomo = {
  id: string
  badge: string
  dot: string
  title: string
  tagline: string
  resuelve: string
  incluye: string[]
  resultado: string
}

export const tomos: Tomo[] = [
  {
    id: 'tomo-1',
    badge: 'Tomo 1',
    dot: 'bg-lime-500',
    title: 'Planificación Anual para Nivel Inicial',
    tagline: 'La base para organizar todo tu año escolar',
    resuelve:
      'Dejás de planificar desde cero: tenés una estructura clara para distribuir contenidos, proyectos y rutinas de todo el ciclo lectivo.',
    incluye: [
      'Planificación anual y distribución mensual',
      'Objetivos generales e ideas de proyectos',
      'Rutinas de sala y modelo semanal',
      'Checklist de organización docente',
    ],
    resultado: 'Una base clara para planificar con más seguridad y adaptar a tu sala.',
  },
  {
    id: 'tomo-2',
    badge: 'Tomo 2',
    dot: 'bg-gold-400',
    title: 'Actividades para Sala de 3 Años',
    tagline: 'Propuestas simples, lúdicas y sensoriales',
    resuelve:
      'Actividades cortas, posibles y respetuosas de los tiempos de los más pequeños, para no quedarte pensando qué hacer cada día.',
    incluye: [
      'Exploración y juegos sensoriales',
      'Motricidad, lenguaje y juego simbólico',
      'Expresión artística y socialización',
      'Rutinas, transiciones y autonomía inicial',
    ],
    resultado: 'Propuestas tiernas y fáciles de adaptar para sala de 3.',
  },
  {
    id: 'tomo-3',
    badge: 'Tomo 3',
    dot: 'bg-orange-400',
    title: 'Actividades para Sala de 4 Años',
    tagline: 'Ideas creativas para una sala más participativa',
    resuelve:
      'Enriquece tus clases en la etapa donde los chicos participan más y sostienen propuestas más variadas.',
    incluye: [
      'Actividades creativas y juegos grupales',
      'Arte, expresión corporal y lenguaje',
      'Matemática inicial y exploración del ambiente',
      'Convivencia, emociones y propuestas por áreas',
    ],
    resultado: 'Ideas variadas para una sala activa, participativa y organizada.',
  },
  {
    id: 'tomo-4',
    badge: 'Tomo 4',
    dot: 'bg-sky-500',
    title: 'Actividades para Sala de 5 Años',
    tagline: 'Autonomía y preparación escolar sin perder el juego',
    resuelve:
      'Propuestas más completas y desafiantes para acompañar la transición hacia primaria, siempre con el juego como eje.',
    incluye: [
      'Prelectura, preescritura y matemática inicial',
      'Juegos reglados y proyectos grupales',
      'Expresión oral y resolución de consignas',
      'Propuestas para la transición a primaria',
    ],
    resultado: 'Actividades completas para una etapa clave del Nivel Inicial.',
  },
  {
    id: 'tomo-5',
    badge: 'Tomo 5',
    dot: 'bg-purple-500',
    title: 'Efemérides y Fechas Especiales',
    tagline: 'Resolvé fechas importantes sin empezar de cero',
    resuelve:
      'Ideas para abordar las efemérides de manera simple, significativa y adaptable, sin apuro ni improvisación.',
    incluye: [
      'Fechas patrias y efemérides escolares',
      'Jardines, Maestro, Familia, Tradición, Primavera',
      'Actividades para actos y para la sala',
      'Disparadores y propuestas con familias',
    ],
    resultado: 'Ideas listas cuando llega una fecha importante.',
  },
  {
    id: 'tomo-6',
    badge: 'Tomo 6',
    dot: 'bg-blush-500',
    title: 'Juegos, Canciones y Dinámicas',
    tagline: 'Recursos para todos los días en la sala',
    resuelve:
      'Recursos rápidos para cambiar la energía, captar la atención u ordenar una transición en cualquier momento del día.',
    incluye: [
      'Juegos de inicio y dinámicas para ronda',
      'Canciones de rutina, saludo y para guardar',
      'Juegos para volver a la calma y días de lluvia',
      'Dinámicas de transición y cierre de jornada',
    ],
    resultado: 'Recursos rápidos para sostener el ritmo del grupo.',
  },
]

export type Bono = {
  id: string
  number: string
  title: string
  description: string
  ideal: string
  value: string
  image: string
}

export const bonos: Bono[] = [
  {
    id: 'bono-1',
    number: 'Bono 01',
    title: '100 Actividades Express',
    description:
      'Ideas rápidas y efectivas para cuando necesitás una actividad sin preparación: juegos, consignas, movimiento, rondas y dinámicas cortas.',
    ideal: 'Ideal para imprevistos, suplencias y transiciones.',
    value: 'ARS 7.990',
    image: 'https://cdn.magicpatterns.com/uploads/7PcJeWUNRjWoEHZNzW4DJh/bono_1.webp',
  },
  {
    id: 'bono-2',
    number: 'Bono 02',
    title: 'Dinámicas para Calmar y Ordenar la Sala',
    description:
      'Estrategias para captar la atención, volver a la calma, ordenar transiciones y recuperar el clima del grupo.',
    ideal: 'Ideal para cuando el grupo está inquieto o disperso.',
    value: 'ARS 7.890',
    image: 'https://cdn.magicpatterns.com/uploads/i1WGL3ZWNjA4i1dKBfQHTG/bono_2.webp',
  },
  {
    id: 'bono-3',
    number: 'Bono 03',
    title: 'Banco de Frases para Informes y Cuadernos',
    description:
      'Frases modelo para comunicar avances, logros y aspectos a seguir trabajando de forma clara, respetuosa y profesional.',
    ideal: 'Ideal para ahorrar tiempo con las palabras adecuadas.',
    value: 'ARS 8.990',
    image: 'https://cdn.magicpatterns.com/uploads/3JhLU1yBWCWdSDWYdurpVv/bono_3.webp',
  },
  {
    id: 'bono-4',
    number: 'Bono 04',
    title: 'Agenda Semanal de la Seño',
    description:
      'Organizá tu semana de forma visual: actividades, materiales, objetivos, fechas importantes, recordatorios y prioridades.',
    ideal: 'Ideal para más orden y menos estrés cada semana.',
    value: 'ARS 6.890',
    image: 'https://cdn.magicpatterns.com/uploads/3FEFZicwvM9uz3wJHuRStv/bono_4.webp',
  },
  {
    id: 'bono-5',
    number: 'Bono 05',
    title: 'Kit para Reuniones con Familias',
    description:
      'Guía práctica para preparar reuniones de forma clara, profesional y segura: estructura sugerida, checklist previo, frases útiles, modelos de comunicación y preguntas clave.',
    ideal: 'Ideal para sentirte más preparada al comunicarte con las familias.',
    value: 'ARS 8.990',
    image: 'https://cdn.magicpatterns.com/uploads/pYodLu6t3TCAHZSFit3HUB/bono_5.webp',
  },
]

export const painPoints = [
  {
    title: 'Horas perdidas buscando actividades sueltas',
    text: 'Una idea en Pinterest, otra en un grupo, otra en Google… y al final nada está realmente organizado para tu sala.',
  },
  {
    title: 'Domingos y noches ocupadas planificando desde cero',
    text: 'Terminás usando tiempo de descanso para resolver lo que podrías tener más claro y estructurado.',
  },
  {
    title: 'Efemérides que llegan de golpe',
    text: 'Día de los Jardines, fechas patrias, Día de la Familia, Primavera, Tradición… y otra vez a buscar ideas a último momento.',
  },
  {
    title: 'Momentos de sala difíciles de manejar',
    text: 'El grupo está inquieto, se dispersa, vuelve acelerado del patio o no escucha la consigna, y necesitás recursos rápidos.',
  },
  {
    title: 'Informes y comunicaciones que te llevan demasiado tiempo',
    text: 'Sabés qué querés decir, pero encontrar las palabras adecuadas para las familias no siempre es fácil.',
  },
  {
    title: 'Sensación de empezar de cero cada semana',
    text: 'Aunque tengas experiencia, la planificación se vuelve una carga cuando no tenés un sistema organizado.',
  },
]

export const comparisons = [
  {
    situation: 'El grupo vuelve alterado del patio',
    without: 'Intentás hablar encima del ruido y terminás repitiendo muchas veces.',
    with: 'Aplicás una transición breve para recuperar la calma antes de seguir.',
  },
  {
    situation: 'Un niño tiene un berrinche',
    without: 'Dudás entre retarlo, dejarlo o frenar toda la actividad.',
    with: 'Sabés cómo validar, poner límite y ayudarlo a volver al grupo.',
  },
  {
    situation: 'Dos nenes se pelean por un juguete',
    without: 'Intervenís rápido, pero el conflicto vuelve a aparecer.',
    with: 'Usás pasos concretos para enseñar turnos, reparación y convivencia.',
  },
  {
    situation: 'La sala no escucha la consigna',
    without: 'Repetís la explicación una y otra vez.',
    with: 'Usás consignas breves, señales y comunicación docente más clara.',
  },
  {
    situation: 'La seño termina agotada',
    without: 'Sentís que todo depende de gritar o improvisar.',
    with: 'Tenés herramientas para conducir con más calma y seguridad.',
  },
]

export const modulos = [
  'Entender la dinámica real de una sala de jardín',
  'Prevención del desorden antes de que aparezca',
  'Conducción del grupo sin gritar',
  'Transiciones ordenadas',
  'Berrinches, llantos y frustraciones',
  'Conflictos entre niños',
  'Comunicación docente que ordena',
  'Rutinas de calma para instalar durante el año',
  'La regulación emocional de la seño',
  'Protocolo Sala en Armonía',
]

export const modulosExtra = [
  '50 frases profesionales para momentos difíciles',
  '20 escenas reales de sala resueltas',
  'Mini protocolo de emergencia para cuando la sala está desbordada',
  'Estrategias para transiciones difíciles',
  'Herramientas para acompañar emociones',
  'Guía para intervenir en conflictos',
  'Rutinas de calma para sostener durante el año',
]

/** Reseñas destacadas que van justo debajo del hero. */
export const heroReviews = [
  {
    quote:
      'No lo podía creer cuando vi que tenía TODO: los 6 tomos, planificación anual, actividades por sala… Dejé de gastar en fotocopias sueltas y ya tengo el año armado. Lo mejor que compré para mi sala.',
    initials: 'MR',
    name: 'Melina R.',
    role: 'Seño de sala de 4 · Córdoba',
  },
  {
    quote:
      'Compré el 360° y no me arrepiento nada. El Sistema Sala en Armonía me cambió la organización del aula entera, no solo la parte de planificación. Se nota que está pensado por alguien que realmente da clases.',
    initials: 'AG',
    name: 'Antonella G.',
    role: 'Seño jardinera · Buenos Aires',
  },
  {
    quote:
      'Los bonos son un montón, pero el que más uso es el banco de frases para los informes. Antes me llevaba horas escribir cada uno, ahora lo adapto y listo. Se paga solo con ese bono.',
    initials: 'FD',
    name: 'Florencia D.',
    role: 'Directora de Nivel Inicial · Rosario',
  },
  {
    quote:
      'Al principio dudé por el precio, pero como tenía la garantía de 7 días lo probé sin drama. A la primera semana ya sabía que me lo quedaba. Ahora llego a mi casa y no tengo que seguir laburando hasta las 11 de la noche.',
    initials: 'CS',
    name: 'Camila S.',
    role: 'Seño de sala de 3 · Mendoza',
  },
  {
    quote:
      'Soy de las que necesitan ver todo escrito para animarse, y esta reseña me hizo click porque me pasa lo mismo: llego a mi casa reventada y todavía me queda planificación. Con el pack ya no me pasa más, abro, elijo la actividad y listo.',
    initials: 'JP',
    name: 'Julieta P.',
    role: 'Seño de sala de 5 · Santa Fe',
  },
]

export const testimonials = [
  {
    quote:
      'El material me ayudó a ordenar todo el año. Antes tenía muchas ideas sueltas, pero nada organizado. Ahora sé dónde buscar cada cosa.',
    initials: 'VT',
    name: 'Valeria T.',
    role: 'Docente de Nivel Inicial',
  },
  {
    quote:
      'El bono de actividades express me sirve muchísimo para esos momentos donde necesito resolver rápido.',
    initials: 'CR',
    name: 'Camila R.',
    role: 'Seño suplente',
  },
  {
    quote:
      'Sistema Sala en Armonía me dio herramientas para no vivir levantando la voz. Me sentí mucho más segura con el grupo.',
    initials: 'DG',
    name: 'Daniela G.',
    role: 'Maestra jardinera',
  },
  {
    quote:
      'El tomo de sala de 5 me ayudó un montón para trabajar propuestas más completas sin perder lo lúdico.',
    initials: 'AM',
    name: 'Ana M.',
    role: 'Docente sala de 5',
  },
  {
    quote: 'El material de planificación me ayudó a dejar de armar todo de cero cada semana.',
    initials: 'SR',
    name: 'Sofía R.',
    role: 'Docente Nivel Inicial',
  },
]

export const faqs = [
  {
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Recibís acceso digital al material para poder empezar a usarlo cuanto antes, sin esperas ni envíos físicos.',
  },
  {
    q: '¿Para qué nivel educativo está pensado?',
    a: 'Está pensado para maestras jardineras y docentes de Nivel Inicial, especialmente sala de 3, 4 y 5 años.',
  },
  {
    q: '¿Sirve si soy seño suplente?',
    a: 'Sí. Es muy útil para suplencias porque incluye actividades express, juegos, dinámicas y recursos rápidos para resolver momentos imprevistos.',
  },
  {
    q: '¿Sirve si recién empiezo?',
    a: 'Sí. Es ideal para docentes recién recibidas porque te da una base organizada para planificar, pensar actividades y sentirte más segura.',
  },
  {
    q: '¿Tengo que imprimir el material?',
    a: 'No necesariamente. Podés consultarlo desde celular, tablet o computadora y usarlo como guía para adaptar ideas a tu sala.',
  },
  {
    q: '¿Es material editable?',
    a: 'No está enfocado en edición de plantillas. Es un pack digital de consulta, planificación, ideas y recursos prácticos para aplicar o adaptar.',
  },
  {
    q: '¿Qué incluye la oferta de ARS 29.990?',
    a: 'Incluye todo el MegaPack Seño Jardín con 6 tomos y 5 bonos, más Sistema Sala en Armonía, el ebook complementario sobre convivencia, calma y conducción de grupo.',
  },
  {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 7 días de garantía. Si no es para vos, podés pedir la devolución.',
  },
]

export const todoIncluye = [
  'Tomo 1 — Planificación Anual para Nivel Inicial',
  'Tomo 2 — Actividades para Sala de 3 Años',
  'Tomo 3 — Actividades para Sala de 4 Años',
  'Tomo 4 — Actividades para Sala de 5 Años',
  'Tomo 5 — Efemérides y Fechas Especiales',
  'Tomo 6 — Juegos, Canciones y Dinámicas',
  'Bono 1 — 100 Actividades Express',
  'Bono 2 — Dinámicas para Calmar y Ordenar la Sala',
  'Bono 3 — Banco de Frases para Informes y Cuadernos',
  'Bono 4 — Agenda Semanal de la Seño',
  'Bono 5 — Kit para Reuniones con Familias',
  'Garantía de 7 días',
  'Pago seguro',
  'Acceso inmediato',
  'Formato digital',
]

export const noMas = [
  'Sin más noches buscando actividades sueltas.',
  'Sin más efemérides resueltas a último momento.',
  'Sin más semanas armadas desde cero.',
  'Sin más informes que te llevan horas por no encontrar las palabras.',
  'Sin más momentos de sala donde sentís que no tenés recursos.',
  'Sin más sensación de que el trabajo nunca termina.',
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/e5Vr3B73oQ1gfTJhkR77hU/mockup_hero.webp',
  pack360: 'https://cdn.magicpatterns.com/uploads/r2AjedCyYEdQRR2hDLMw9y/MEGAPACK_SENO_JARDIN_360.webp',
  bonos: 'https://cdn.magicpatterns.com/uploads/28cgW5AuXF8X4JxXaWJGcx/5_bonos.webp',
}
